'use client';

import { useEffect, useRef } from 'react';

import { getLogger } from '@/logger/logger';
import { initializeAuth } from '@/utils/auth/init.util';

const logger = getLogger('auth-init-hook');

export function useAuthInit() {
  const hasInitialized = useRef(false);

  useEffect(() => {
    if (hasInitialized.current) {
      logger.info('Auth already initialized, skipping');
      return;
    }

    hasInitialized.current = true;
    logger.info('Starting auth initialization');
    initializeAuth();
  }, []);
}
